import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5 3C4.44772 3 4 3.44772 4 4C4 4.55228 4.44772 5 5 5H19C19.5523 5 20 4.55228 20 4C20 3.44772 19.5523 3 19 3H5ZM4 16C4 15.4477 4.44772 15 5 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16ZM4 8C4 7.44772 4.44772 7 5 7H19C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9H5C4.44772 9 4 8.55228 4 8ZM4 12C4 11.4477 4.44772 11 5 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H5C4.44772 13 4 12.5523 4 12ZM4 20C4 19.4477 4.44772 19 5 19H9C9.55228 19 10 19.4477 10 20C10 20.5523 9.55228 21 9 21H5C4.96548 21 4.93137 20.9983 4.89776 20.9948C4.3935 20.9436 4 20.5178 4 20Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 3.565C3 3.25296 3.25296 3 3.565 3H12.435C12.747 3 13 3.25296 13 3.565C13 3.87704 12.747 4.13 12.435 4.13H3.565C3.25296 4.13 3 3.87704 3 3.565ZM3 10.565C3 10.253 3.25296 10 3.565 10H12.435C12.747 10 13 10.253 13 10.565C13 10.877 12.747 11.13 12.435 11.13H3.565C3.25296 11.13 3 10.877 3 10.565ZM3.565 5C3.25296 5 3 5.25296 3 5.565C3 5.87704 3.25296 6.13 3.565 6.13H12.435C12.747 6.13 13 5.87704 13 5.565C13 5.25296 12.747 5 12.435 5H3.565ZM3 7.565C3 7.25296 3.25296 7 3.565 7H6.435C6.74704 7 7 7.25296 7 7.565C7 7.87704 6.74704 8.13 6.435 8.13H3.565C3.25296 8.13 3 7.87704 3 7.565ZM3.565 12C3.25296 12 3 12.253 3 12.565C3 12.877 3.25296 13.13 3.565 13.13H6.435C6.74704 13.13 7 12.877 7 12.565C7 12.253 6.74704 12 6.435 12H3.565Z"
  />
);

export const WrapOnIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="WrapOn" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
